import styled from "styled-components";

export const ExpandableContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const ChildrenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const ShowMoreButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 12px;
  width: 100%;
`;

export const ShowMoreButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: transparent;
  border: 1px solid #e0e0e0;
  border-radius: 100%;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
  
  &:hover {
    background-color: #f5f5f5;
    border-color: #ccc;
  }
  
  &:active {
    transform: scale(0.95);
  }
`; 